import { getPrimaryColor } from "./themeConfig";

export default function getColor(color) {
  if (color === "primaryOrange") {
    return getPrimaryColor();
  }
  if (color === "primaryYellow") {
    return "#FFD700";
  }
  if (color === "secondaryGreen") {
    return "#2DC84D";
  }
  return getPrimaryColor();
}
